import { useContext, useEffect, useRef } from "react";
import { OwnershipContext } from "../contexts/OwnershipContext.js";
export var useOwnership = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, backendOwner = ref.backendOwner, framework = ref.framework, frontendOwner = ref.frontendOwner, invisible = ref.invisible;
    var context = useContext(OwnershipContext);
    if (!context) {
        throw new Error("useOwnership must be used within an OwnershipProvider");
    }
    // Save the status BEFORE making any changes
    var prevOwnership = useRef(null);
    var hasModified = useRef(false);
    // Save the initial state only if it has not yet been modified.
    if (prevOwnership.current === null && !hasModified.current) {
        var _backendOwner, _framework, _frontendOwner;
        prevOwnership.current = {
            backendOwner: (_backendOwner = context.backendOwner) !== null && _backendOwner !== void 0 ? _backendOwner : null,
            framework: (_framework = context.framework) !== null && _framework !== void 0 ? _framework : null,
            frontendOwner: (_frontendOwner = context.frontendOwner) !== null && _frontendOwner !== void 0 ? _frontendOwner : null
        };
    }
    useEffect(function() {
        if (!invisible && (backendOwner || framework || frontendOwner)) {
            // Mark that the context has been modified
            hasModified.current = true;
            context.update({
                backendOwner: backendOwner !== null && backendOwner !== void 0 ? backendOwner : null,
                framework: framework !== null && framework !== void 0 ? framework : null,
                frontendOwner: frontendOwner !== null && frontendOwner !== void 0 ? frontendOwner : null
            });
        }
    }, [
        backendOwner,
        framework,
        frontendOwner,
        invisible
    ]);
    // When the component unmounts, restore the previous page
    useEffect(function() {
        return function() {
            if (hasModified.current && prevOwnership.current) {
                context.update(prevOwnership.current);
            }
        };
    }, [
        context.update
    ]);
    var _backendOwner1, _framework1, _frontendOwner1;
    return {
        backendOwner: (_backendOwner1 = context.backendOwner) !== null && _backendOwner1 !== void 0 ? _backendOwner1 : null,
        framework: (_framework1 = context.framework) !== null && _framework1 !== void 0 ? _framework1 : null,
        frontendOwner: (_frontendOwner1 = context.frontendOwner) !== null && _frontendOwner1 !== void 0 ? _frontendOwner1 : null
    };
};

//# sourceMappingURL=useOwnership.js.map